import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
    },
    modal: {
      background: theme.palette.secondary.main,
      borderRadius: 5,
      maxWidth: 590,
      padding: '32px 24px',
      textAlign: 'center',
      '& a': {
        marginRight: SMALL_MARGIN,
      },
    },
    modalCloseBtn: {
      display: 'block',
      cursor: 'pointer',
      height: 14,
      marginBottom: SMALL_MARGIN,
      marginLeft: 'auto',
      width: 14,
    },
    modalDescription: {
      color: colorsPalette.gray,
      margin: '24px 0 50px',
    },
    btn: {
      minWidth: 150,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    cancelBtn: {
      marginRight: SMALL_MARGIN,
      [theme.breakpoints.down('sm')]: {
        marginBottom: SMALL_MARGIN,
        marginRight: 0,
      },
    },
    modalContent: {
      color: colorsPalette.gray,
      fontSize: 20,
      lineHeight: 1.5,
      marginTop: MIDDLE_MARGIN,
      marginBottom: MIDDLE_MARGIN,
      textAlign: 'center',
    },
    formField: {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        minWidth: 412,
      },
    },
  }),
);

export default useStyles;
